import { html } from 'lit';
import { createElement, SendHorizontal } from 'lucide';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-send')
export class PdsIconSend extends PdsIcon {
  createIconElement(): SVGElement {
    return createElement(SendHorizontal);
  }

  render() {
    return html`${this.icon}`;
  }
}
